const getSplitValues = textValue =>
  textValue
    .replace(/\n/g, ',')
    .split(',')
    .map(value => value.trim());

export { getSplitValues };
